export const questions = [
  {
    id: 1,
    key: 'constants.quizQuestions.q1',
    question_text:
      'Знаете ли вы, что входит в ваши функциональные обязанности?',
  },
  {
    id: 2,
    key: 'constants.quizQuestions.q2',
    question_text:
      'Часто ли вам приходится заниматься тем, что не входит в ваши функциональные обязанности?',
  },
  {
    id: 3,
    key: 'constants.quizQuestions.q3',
    question_text: 'Довольны ли вы стилем управления руководителя компании?',
  },
  {
    id: 4,
    key: 'constants.quizQuestions.q4',
    question_text:
      'Как вы считаете, берет ли руководитель во внимание ваше мнение, решая ту или иную задачу/проблему?',
  },
  {
    id: 5,
    key: 'constants.quizQuestions.q5',
    question_text: 'Знаете ли вы цели вашей компании?',
  },
  {
    id: 6,
    key: 'constants.quizQuestions.q6',
    question_text: 'Знаете ли вы цель на своей рабочей должности?',
  },
  {
    id: 7,
    key: 'constants.quizQuestions.q7',
    question_text: 'Считаете ли вы свою работу «вызовом»?',
  },
  {
    id: 8,
    key: 'constants.quizQuestions.q8',
    question_text:
      'Позволяет ли ваша работа в полной мере реализовывать ваши способности?',
  },
  {
    id: 9,
    key: 'constants.quizQuestions.q9',
    question_text: 'Гордитесь ли вы работой в компании?',
  },
  {
    id: 10,
    key: 'constants.quizQuestions.q10',
    question_text:
      'Посоветовали бы вы своему близкому другу работу в компании?',
  },
  {
    id: 11,
    key: 'constants.quizQuestions.q11',
    question_text: 'Не кажется ли вам, что вы работаете больше, чем надо?',
  },
  {
    id: 12,
    key: 'constants.quizQuestions.q12',
    question_text:
      'Считаете ли вы, что за свою работу вы получаете справедливую заработную плату?',
  },
  {
    id: 13,
    key: 'constants.quizQuestions.q13',
    question_text:
      'Вы бы хотели получать ЗП согласно сделанной работе, то что вы реально заслужили (по KPI)?',
  },
  {
    id: 14,
    key: 'constants.quizQuestions.q14',
    question_text:
      'Чувствуете ли вы уверенность в завтрашнем дне, работая в компании?',
  },
  {
    id: 15,
    key: 'constants.quizQuestions.q15',
    question_text:
      'Вы считаете, что ваша текущая должность соответствует вашему уровню профессионализма и заслугам перед компанией?',
  },
  {
    id: 16,
    key: 'constants.quizQuestions.q16',
    question_text:
      'Можете ли вы самостоятельно принимать решение на занимаемой должности?',
  },
]
